import React, {useEffect, useState} from "react";
// import logo from "./images/electro.png";
import logo from "./images/LOGO_RPP2.png";

import whatsapp from "./images/whatsapp.png";
import "./App.css";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import {DataGrid} from "@mui/x-data-grid";
import InputAdornment from "@mui/material/InputAdornment";
import {AccountCircle,} from "@mui/icons-material";
import KeyIcon from "@mui/icons-material/Key";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import LogoutIcon from '@mui/icons-material/Logout';
import LockIcon from "@mui/icons-material/Lock"; // Usa candado como en la segunda imagen
import { Tooltip } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  Stack,
  OutlinedInput,
  Checkbox,
} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard'; // ícono tarjeta
import { useTheme, useMediaQuery } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "50%",
    },
    fab: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    }
  },
}));

//tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
        {value === index && (
            <Box sx={{ p: 3 }}>
              <Typography component={'span'} variant={'body2'}>{children}</Typography>
            </Box>
        )}
      </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [logged, setLogged] = useState(false);
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [isvalid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");
  const [bills, setBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [monto, setMonto] = useState(0);
  const [monto2, setMonto2] = useState(0);
  const [totalCartera, setTotalCartera] = useState(0);
  const [totalVencido, setTotalVencido] = useState(0);
  const [cupoAsignado, setCupoAsignado] = useState(0);
  const [cupoDisponible, setCupoDisponible] = useState(0);
  const [dataDetalle, setDataDetalle] = useState([]);
  const [referencia, setReferencia] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("factura");
  const options = { style: "currency", currency: "USD" };
  const numberFormat2 = new Intl.NumberFormat("en-US", options);
  //registro
  const [usernameRegistro, setUsernameRegistro] = useState("");
  const [passwordRegistro, setPasswordRegistro] = useState("");
  const [masterPasswordRegistro, setMasterPasswordRegistro] = useState("");
  const [email, setEmail] = useState("");
  const [numeroFactura, setNumeroFactura] = useState("");
  //tabs
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes = useStyles();

  const { width } = useWindowDimensions();
  const sizeCols = width / 9.5;

  const [selectedBills,  setSelectedBills]  = useState([]); // facturas
  const [selectedOffers, setSelectedOffers] = useState([]); // cotizaciones
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));  // true cuando < 960 px
  // ¿Hay facturas/cotizaciones seleccionadas?
  const tieneMontoSeleccionado = monto > 0;          // (monto está en centavos)

  // ¿El usuario escribió un valor distinto al original?
  //  – cuando escribes en “Pagar un valor diferente”  actualizas `monto`,
  //    pero `monto2` sigue guardando el total original de las facturas.
  const tienePagoParcial      = monto > 0 && monto !== monto2;

  const columns = [
    {
      field: "cardCode",
      headerName: "Cod. Usuario",
      flex: 0.7,
      minWidth: 90,
      editable: false,
      renderHeader: (params) => (
        <Tooltip title="Cod. Usuario" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),  
    },
    {
      field: "cardName",
      headerName: "Nombre",
      flex: 1,
      minWidth: 120,
      editable: false,
      renderHeader: (params) => (
        <Tooltip title="Nombre" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "docDate",
      headerName: "Fecha Documento",
      flex: 0.8,
      minWidth: 110,
      editable: false,
      renderHeader: (params) => (
        <Tooltip title="Fecha Documento" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "docDueDate",
      headerName: "Fecha Vencimiento Doc",
      flex: 0.9,
      minWidth: 130,
      sortable: true,
      renderHeader: (params) => (
        <Tooltip title="Fecha Vencimiento Doc" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "state",
      headerName: "Estado",
      flex: 0.7,
      minWidth: 100,
      sortable: true,
      renderHeader: (params) => (
        <Tooltip title="Estado" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "dias_mora",
      headerName: "Días en mora",
      flex: 0.6,
      minWidth: 100,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: (params) => (
        <Tooltip title="Días en mora" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "billNum",
      headerName: "Num. Factura",
      flex: 0.8,
      minWidth: 110,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Num. Factura" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),  
    },
    {
      field: "saldoAux",
      headerName: "Saldo",
      flex: 1,
      minWidth: 110,
      editable: false,
      renderHeader: (params) => (
        <Tooltip title="Saldo" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
  ];
  
  const columnsOffer = [
    {
      field: "cardCode",
      headerName: "Cod. Usuario",
      flex: 0.7,
      minWidth: 90,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Cod. Usuario" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "cardName",
      headerName: "Nombre",
      flex: 1,
      minWidth: 120,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Nombre" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "docDate",
      headerName: "Fecha Documento",
      flex: 0.8,
      minWidth: 110,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Fecha Documento" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "docDueDate",
      headerName: "Fecha Vencimiento Doc",
      flex: 0.9,
      minWidth: 130,
      sortable: true, 
      renderHeader: (params) => (
        <Tooltip title="Fecha Vencimiento Doc" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "billNum",
      headerName: "Num. Factura",
      flex: 0.8,
      minWidth: 110,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Num. Factura" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "saldoAux",
      headerName: "Saldo",
      flex: 1,
      minWidth: 110,
      editable: false,  
      renderHeader: (params) => (
        <Tooltip title="Saldo" arrow placement="top">
          <span style={{ color: '#000', fontWeight: 'bold' }}>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
  ];
  
  const orangeGridTheme = createTheme({
    components: {
      MuiDataGrid: {
        styleOverrides: {
          /* <<< QUITA el borde gris >>> */
          root: {
            border: 'none',          // <-- aquí lo anulamos
          },
          /* fila completa de encabezados */
          columnHeaders: {
            backgroundColor: '#F25C05',
            color: '#000',
            fontWeight: 'bold',
            borderRadius: '10px',
          },
          /* texto del título (para que se parta en dos líneas si hace falta) */
          columnHeaderTitle: {
            whiteSpace: 'normal',
            textAlign: 'center',
            lineHeight: 1.2,
            fontWeight: 'bold',
          },
        },
      },
    },
  });
  

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://checkout.wompi.co/widget.js";
    script.async = true;
    document.body.appendChild(script);
    let userTmp = localStorage.getItem('username')
    let passTmp = localStorage.getItem('password')
    if(userTmp!== undefined && userTmp !== ''){
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ card_code: userTmp, pass: passTmp }),
      };
      fetch("https://electrofrenorr.herokuapp.com/client/login", requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.Status !== 200) {
            console.log(data.Message)
          } else {
            setLogged(true);
            getAllBillsByClient(userTmp, data.Payload.Token);
            setTimeout(function(){
              getAllOfferssByClient(userTmp, data.Payload.Token);
            }, 300)

          }
        })
        .catch((error) => {
          console.log(error)
        });
    }
    
  }, []);

  const getAllBillsByClient = (value, token2) => {
    const requestOptions = {
      method: "GET",
    };
    let url =
      "https://electrofrenorr.herokuapp.com/facturas/cliente/" +
      value.toString();

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        let tempVencido = 0;
        let tempCartera = 0;
        setTotalCartera(0);
        setTotalVencido(0);
        setCupoAsignado(0);
        setCupoDisponible(0);
        let tempDisponible = 0;
        let temp = data.map(function (it) {
          let today = new Date();
          let splitedDate = it.DocDueDate.split("/");
          let dueDate = new Date(
            splitedDate[2],
            splitedDate[1] - 1,
            splitedDate[0]
          );
          let diffTime = today.getTime() - dueDate.getTime();
          let diffDays = Math.ceil(diffTime / (1000 * 3600 * 24)) - 1;
          let estado =
            diffDays > 0
              ? "Vencida"
              : diffDays >= -5
              ? "Por Vencer"
              : "Sin Vencer";
          setCupoAsignado(it["Cupo Asignado"]);
          tempDisponible = it["Cupo Asignado"];
          tempCartera = tempCartera + it.Saldo;
          if (estado === "Vencida") {
            tempVencido = tempVencido + it.Saldo;
          }
          return {
            cardCode: it.CardCode,
            cardName: it.CardName,
            docDate: it.DocDate,
            docDueDate: it.DocDueDate,
            billNum: it.DocNum,
            saldo: it.Saldo,
            saldoAux: "$" + new Intl.NumberFormat("COP").format(it.Saldo),
            doc_entry: it.DocEntry,
            state: estado,
            dias_mora: diffDays,
          };
        });
        setTotalVencido(tempVencido);
        setTotalCartera(tempCartera);
        setCupoDisponible(tempDisponible - tempCartera);
        setBills(temp);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAllOfferssByClient = (value, token2) => {
    const requestOptions = {
      method: "GET",
    };
    let url =
        "https://electrofrenorr.herokuapp.com/cliente/ofertas/" +
        value.toString();
    fetch(url, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          let temp = data.map(function (it) {
            return {
              cardCode: it.CardCode,
              cardName: it.CardName,
              docDate: it.DocDate,
              docDueDate: it.DocDueDate,
              billNum: it.DocNum,
              saldo: it.Saldo,
              saldoAux: "$" + new Intl.NumberFormat("COP").format(it.Saldo),
              doc_entry: it.DocEntry
            };
          });
          setOffers(temp);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const setDataWompi= (ids, type) => {
    let filteredBillsTemp = filteredBills
    let filteredOffersTemp = filteredOffers

    switch (type) {
      case 'bills':
        filteredBillsTemp = bills.filter(function (element) {
          return ids.includes(element.billNum);
        });
        break;
      case 'offers':
        filteredOffersTemp = offers.filter(function (element) {
          return ids.includes(element.billNum);
        });
        break;
    }


    setMonto(0);
    setMonto2(0);
    let data = [];
    let suma = 0;
    let ref = "";
    let filtered = filteredBillsTemp.concat(filteredOffersTemp)

    
    const fecha = new Date();
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');
    const segundos = String(fecha.getSeconds()).padStart(2, '0');

    const fechaFormateada = `${anio}${mes}${dia}${horas}${minutos}${segundos}`;

    filtered.forEach((element) => {
      suma = suma + element.saldo;
      ref = element.cardCode;
      data.push({
        reference: ref + "-" + fechaFormateada,
        id: element.billNum,
        amount: element.saldo,
        doc_entry: element.doc_entry,
      });
    });
    setMonto(suma * 100);
    setMonto2(suma * 100);
    setReferencia(ref + "-" + fechaFormateada);
    setDataDetalle(data);
    setIsValid(true);
    setFilteredBills(filteredBillsTemp)
    setFilteredOffers(filteredOffersTemp)
  };

  const handleSubmit = (e) => {
        e.preventDefault();

        const formElement = e.target;
         

        let tempBills = [];
        if (dataDetalle.length === 1) {
            tempBills.push({
                reference: dataDetalle[0].reference,
                id: dataDetalle[0].id,
                amount: Math.round(monto),
                doc_entry: dataDetalle[0].doc_entry,
            });
        } else {
            tempBills = dataDetalle.map(function (it) {
                return {
                    reference: it.reference,
                    id: it.id,
                    amount: Math.round(it.amount * 100),
                    doc_entry: it.doc_entry,
                };
            });
        }

        // --- NUEVO PAYLOAD ESTRUCTURADO ---
        // Ahora enviamos un objeto que contiene el array de detalles y los valores globales para Wompi
        const payload = {
            facturas: tempBills, // Tu array original
            total: Math.round(monto).toString(), // El valor total exacto en centavos y en string
            // referencia_wompi: referencia // La referencia general de este pago
        };

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // Enviamos el nuevo objeto
            body: JSON.stringify(payload),
        };

        fetch("https://electrofrenorr.herokuapp.com/event/create", requestOptions)
          .then((response) => response.json())
          .then((data) => {
              if (data.Status === 200) {
                  // 1. CAMBIO AQUÍ: Leer la propiedad exacta 'Message'
                  const hashGenerado = data.Message; 
                  
                  const inputIntegridad = document.createElement("input");
                  inputIntegridad.type = "hidden";
                  inputIntegridad.name = "signature:integrity";
                  inputIntegridad.value = hashGenerado;

                  // 2. CAMBIO AQUÍ: Para imprimirlo bien en consola
                  // console.log("hash: " + hashGenerado); 
                  // console.log(inputIntegridad)

                  formElement.appendChild(inputIntegridad);
                  formElement.submit();
              } else {
                  // 3. Opcional: Si los errores también vienen en 'Message', ajusta esto
                  setMessage(data.Message || data.message || "Error desconocido"); 
                  setOpen(true);
              }
        })
        .catch((error) => {
            setMessage("No se pudo enviar el registro");
            setOpen(true);
        });
    };

  // NUEVA versión
  const setPagoParcial = (value) => {
    /* ── 1. Sanitizar entrada ─────────────────────────────── */
    const clean = value.toString().replace(/[^\d]/g, '');   // quita puntos, comas, etc.
    const tmpValue = Number(clean) * 100;                   // a centavos

    /* ── 2. Si el campo queda vacío o 0 → limpia todo ──────── */
    if (!clean || tmpValue === 0) {
      setMonto(0);                  // input de “monto” en 0
      setIsValid(false);

      // ↓↓↓ NUEVO: vaciamos selecciones y arrays auxiliares ↓↓↓
      setSelectedBills([]);          // <— estado nuevo (ver paso 2)
      setSelectedOffers([]);
      setDataDetalle([]);
      setFilteredBills([]);
      setFilteredOffers([]);
      return;
    }

    /* ── 3. Si excede el saldo de la(s) factura(s) ─────────── */
    if (tmpValue > monto2) {
      setMessage('El valor a pagar no puede ser mayor al valor de la factura seleccionada');
      setOpen(true);
      setIsValid(false);
      return;
    }

    /* ── 4. Valor correcto ─────────────────────────────────── */
    setMonto(tmpValue);
    setIsValid(true);
  };




  const login = () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ card_code: username, pass: password }),
    };
    fetch("https://electrofrenorr.herokuapp.com/client/login", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.Status !== 200) {
          setMessage(data.Message);
          setOpen(true);
        } else {
          setLogged(true);
          localStorage.setItem('username', username)
          localStorage.setItem('password', password)
          getAllBillsByClient(username, data.Payload.Token);
          getAllOfferssByClient(username, data.Payload.Token);
        }
      })
      .catch((error) => {
        setMessage("No se pudo iniciar sesión");
        setOpen(true);
      });
  };

  const logup = () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        card_code: usernameRegistro,
        pass: passwordRegistro,
        mail: email,
        num_doc: parseInt(numeroFactura),
        is_offer: tipoDocumento !== "factura"
      }),
    };
    fetch("https://electrofrenorr.herokuapp.com/client/create", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.Status !== 201) {
          setMessage(data.Message);
          setOpenRegister(false);
          setOpen(true);
        } else {
          setMessage(data.Message);
          setOpenRegister(false);
          setOpenSuccess(true);
        }
      })
      .catch((error) => {
        setMessage("No se pudo iniciar sesión");
        setOpenRegister(false);
        setOpen(true);
      });
  };


  const changePassword = () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        card_code: usernameRegistro,
        new_pass: passwordRegistro,
        master_pass: masterPasswordRegistro,
      }),
    };
    fetch("https://electrofrenorr.herokuapp.com/client/change/pass", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.Status !== 200) {
          setMessage(data.Message);
          setOpenRegister(false);
          setOpen(true);
        } else {
          setMessage(data.Message);
          setOpenRegister(false);
          setOpenSuccess(true);
        }
      })
      .catch((error) => {
        setMessage("No se pudo iniciar sesión");
        setOpenRegister(false);
        setOpen(true);
      });
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  return (
    <div>
      {logged ? (
        <ThemeProvider theme={orangeGridTheme}>
        <Box sx={{ backgroundColor: '#050A0E', color: '#fff', p: 2 }}>
          <Typography variant="h4" sx={{ textAlign: 'center', mt: 2, color: '#fff', fontWeight: 'bold', fontStyle: 'italic' }}>
            ¡Hola, {bills[0]?.cardName || 'Cliente'}!
          </Typography>

          <Grid container spacing={2} sx={{ height: { md: 'calc(100vh - 120px)', xs: 'auto' } }}>
            <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              
              {/* FACTURAS */}
              <Box sx={{ flex: 1, display: 'flex', flex: { md: 1, xs: 'unset' }, flexDirection: 'column' }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', fontStyle: 'italic' }}>¡TUS FACTURAS PENDIENTES!</Typography>
                <Box sx={{ bgcolor: '#fff', borderRadius: 4, flex: 1 }}>
                  {bills.length > 0 ? (
                    <DataGrid
                      autoHeight={isMobile}
                      getRowId={(r) => r.billNum}
                      rows={bills}
                      columns={columns}
                      hideFooter
                      checkboxSelection
                      sx={{
                        color: '#000',
                        border: 'none',
                        backgroundColor: '#fff',
                        borderRadius: 2
                      }}
                      selectionModel={selectedBills}
                      onSelectionModelChange={(ids) => {
                        setSelectedBills(ids);                // <- guarda la selección
                        if (ids.length) {
                          setDataWompi(ids, 'bills');
                        } else {
                          setDataWompi([], 'bills');
                          setIsValid(false);
                        }
                      }}
                    />
                  ) : (
                    <Typography sx={{ textAlign: 'center', py: 2 }}>
                      Estimado Cliente, No tiene facturas pendientes por pagar.
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* COTIZACIONES */}
              <Box sx={{ flex: 1, display: 'flex', flex: { md: 1, xs: 'unset' }, flexDirection: 'column' }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', fontStyle: 'italic' }}>¡TUS COTIZACIONES!</Typography>
                <Box sx={{ bgcolor: '#fff', borderRadius: 4, flex: 1}}>
                  {offers.length > 0 ? (
                    <DataGrid
                      autoHeight={isMobile}
                      getRowId={(r) => r.billNum}
                      rows={offers}
                      columns={columnsOffer}
                      hideFooter
                      checkboxSelection
                      sx={{
                        color: '#000',
                        border: 'none',
                        backgroundColor: '#fff',
                        borderRadius: 2
                      }}
                      selectionModel={selectedOffers}
                      onSelectionModelChange={(ids) => {
                        setSelectedOffers(ids);
                        if (ids.length) {
                          setDataWompi(ids, 'offers');
                        } else {
                          setDataWompi([], 'offers');
                          setIsValid(false);
                        }
                      }}

                    />
                  ) : (
                    <Typography sx={{ textAlign: 'center', py: 2 }}>
                      Estimado Cliente, No tiene ofertas disponibles en el momento.
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* PANEL DERECHO */}
            <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 5 }}>
                {[
                  ['Total Cartera',      totalCartera],
                  ['Total Vencido',      totalVencido],
                  // ['Total Sin Vencer', totalSinVencer],   // ← descomenta si lo calculas
                  ['Cupo Asignado',      cupoAsignado],
                  ['Cupo Disponible',    cupoDisponible],
                ].map(([label, value]) => (
                  <Box                    // contenedor de la fila
                    key={label}
                    sx={{
                      display: 'flex',
                      width: '100%',
                      columnGap: '5px',          // ← línea negra vertical
                      mb: 1.2,                   // ← espacio entre píldoras
                      borderRadius: '18px',
                      overflow: 'hidden', // mantiene las esquinas redondeadas
                    }}
                  >
                    {/* COLUMNA 1 ─ etiqueta naranja */}
                    <Box
                      sx={{
                        flex: '0 0 45%',              // ancho fijo ~45 %
                        bgcolor: '#F25C05',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1.5, py: 1,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontSize: '0.95rem',
                        lineHeight: 1.2,
                      }}
                    >
                      {label}
                    </Box>

                    {/* COLUMNA 2 ─ valor blanco */}
                    <Box
                      sx={{
                        flex: 1,                      // ocupa el resto del ancho
                        bgcolor: '#fff',
                        color: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1.5, py: 1,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontSize: '0.95rem',
                      }}
                    >
                      {numberFormat2.format(value)}&nbsp;COP
                    </Box>
                  </Box>
                ))}

                <Stack spacing={2}>
                  {/* Valor facturas seleccionadas (solo lectura) */}
                  <OutlinedInput
                    fullWidth
                    value={`Valor facturas seleccionadas: ${numberFormat2.format(
                      monto / 100,
                    )} COP`}
                    readOnly                                    // evita edición, pero no lo “engrisa”
                    startAdornment={
                      <InputAdornment position="start">
                        <Checkbox
                          checked={tieneMontoSeleccionado}   // ✅ solo marcado si `monto > 0`
                          disableRipple                          // sin animación extra
                          sx={{ p: 0, mx: 0.5 }}
                        />
                      </InputAdornment>
                    }
                    sx={{
                      fontWeight: 'bold',
                      bgcolor: '#fff',
                      borderRadius: 10,
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                      input: { textAlign: 'start' },
                    }}
                  />

                  {/* Pagar un valor diferente (editable) */}
                  <OutlinedInput
                    fullWidth
                    placeholder="Pagar un valor diferente:"
                    disabled={dataDetalle.length > 1}           // tu regla original
                    startAdornment={
                      <InputAdornment position="start">
                        <Checkbox
                          checked={tienePagoParcial}         // ✅ se marca solo si el usuario escribió un valor > 0
                          disableRipple
                          sx={{ p: 0, mx: 0.5 }}
                        />
                      </InputAdornment>
                    }
                    onChange={(e) => setPagoParcial(e.target.value)}
                    sx={{
                      bgcolor: '#fff',
                      borderRadius: 10,
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                      input: { textAlign: 'start' },
                    }}
                  />

                  <Typography variant="caption" sx={{ color: '#ccc', mt: 0.5, fontWeight: 'bold', fontStyle: 'italic',textAlign: 'center' }}>
                    ¡Para pagos parciales de una factura, puedes editar el valor a pagar!
                  </Typography>
                </Stack>

                <form
                  onSubmit={handleSubmit}
                  action="https://checkout.wompi.co/p/"
                  method="GET"
                  style={{ width: '100%' }}
                >
                  <input type="hidden" name="public-key" value="pub_prod_tTJFivVHWPPq61LzO7AQjJO0J3SB2oSd" />
                  <input type="hidden" name="currency" value="COP" />
                  <input type="hidden" name="amount-in-cents" value={Math.round(monto)} />
                  <input type="hidden" name="reference" value={referencia} />
                  <Box              /* ← Contenedor centrador */
                    mt={2}
                    display="flex"
                    justifyContent="center"
                    width="100%"
                  >
                    {/* ---------- PÍLDORA ---------- */}
                    <Box
                      sx={{
                        display: 'inline-flex',
                        gap: 1,                 // ← separa ±8 px; usa 0.5 ó 2 si quieres menos/más
                        borderRadius: 28,
                        overflow: 'hidden',
                      }}
                    >
                      {/* BOTÓN PAGAR */}
                      <Button
                      type="submit"
                      variant="contained"
                      disabled={!isvalid}
                      startIcon={<CreditCardIcon sx={{ fontSize: 20 }} />}
                      sx={{
                        textTransform: 'none',
                        fontStyle: 'italic',
                        fontWeight: 'bold',
                        px: 4,
                        backgroundColor: '#F25C05',
                        color: '#fff',
                        borderRadius: 0,
                        boxShadow: 'none',
                        '&:hover': { backgroundColor: '#F25C05' },

                        /* --- ESTILO CUANDO ESTÁ DESHABILITADO --- */
                        '&.Mui-disabled': {
                          backgroundColor: '#FFB07B',
                          color: '#fff',
                          opacity: 1,
                        },
                      }}
                    >
                      Pagar
                    </Button>

                      {/* BOTÓN CERRAR SESIÓN */}
                      <Button
                        variant="contained"
                        onClick={() => {
                          setLogged(false);
                          localStorage.clear();
                        }}
                        startIcon={<LogoutIcon sx={{ fontSize: 20 }} />}
                        sx={{
                          textTransform: 'none',
                          fontStyle: 'italic',
                          fontWeight: 'bold',
                          px: 4,
                          backgroundColor: '#fff',
                          color: '#000',
                          /* quitamos la línea blanca porque ahora hay un corte negro */
                          borderRadius: 0,
                          boxShadow: 'none',
                          '&:hover': { backgroundColor: '#f5f5f5' },
                        }}
                      >
                        Cerrar Sesión
                      </Button>
                    </Box>
                  </Box>

                </form>

                {/* BANNER WHATSAPP ---------------------------------------------------- */}
                <Box
                  mt={3}
                  display="flex"
                  justifyContent="space-between"   // separa texto y botón
                  alignItems="center"
                  gap={2}                          // margen a ambos lados en pantallas estrechas
                >
                  {/* ── Sección 1 · Texto ─────────────────────────────────────────── */}
                  <Typography sx={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                    ¿Tienes dudas o solicitudes sobre el área de cartera? Un asesor te atenderá por WhatsApp.
                  </Typography>

                  {/* ── Sección 2 · Botón + icono ─────────────────────────────────── */}
                  <a
                    href="https://api.whatsapp.com/send/?phone=573008250414"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                      {/* Botón verde tipo píldora */}
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: '#25D366',      // verde WhatsApp
                          color: '#fff',
                          fontWeight: 'bold',
                          textTransform: 'none',
                          px: 4,
                          borderRadius: '24px',
                          boxShadow: 'none',
                          fontStyle: 'italic',
                          '&:hover': { backgroundColor: '#1EBE5D', boxShadow: 'none' },
                        }}
                      >
                        Información
                      </Button>

                      {/* Icono superpuesto */}
                      <img
                        src={whatsapp}                    // tu imagen ya importada
                        alt="WhatsApp"
                        style={{
                          position: 'absolute',
                          right: -9,                     // sobresale 18 px a la derecha
                          top: '7%',
                          transform: 'translateY(-50%)',
                          width: 32,                      // ajusta a gusto
                          pointerEvents: 'none',          // ignora clics
                        }}
                      />
                    </Box>
                  </a>
                </Box>

              </Box>
            </Grid>
          </Grid>
        </Box>
        </ThemeProvider>

      ) : (
        <div style={{ textAlign: "center", marginTop: "10%", color: "#fff", position: "relative" }}>
          <img src={logo} alt="Logo" style={{ width: 300, marginBottom: "20px" }} />
          <br />

          {/* CONTENEDOR CENTRAL - ancho fijo */}
          <div style={{ width: "300px", margin: "0 auto", position: "relative" }}>

            {/* INPUT USUARIO */}
            <div style={{ position: "relative", marginBottom: "15px" }}>
              <AccountCircle
                style={{
                  color: "#F25C05",
                  fontSize: "26px",
                  position: "absolute",
                  left: "-40px",
                  top: "50%",
                  transform: "translateY(-50%)"
                }}
              />
              <input
                type="text"
                placeholder="Usuario"
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  width: "calc(100% - 25px)", // <-- CAMBIO CLAVE
                  padding: "10px",
                  fontSize: "16px",
                  border: "2px solid #F25C05",
                  borderRadius: "6px",
                  outline: "none",
                  textAlign: "center",
                  fontStyle: "italic" // <-- ESTO HACE QUE LA LETRA SEA CURSIVA
                }}
              />
            </div>

            {/* INPUT CONTRASEÑA */}
            <div style={{ position: "relative", marginBottom: "25px" }}>
              <LockIcon
                style={{
                  color: "#F25C05",
                  fontSize: "26px",
                  position: "absolute",
                  left: "-40px",
                  top: "50%",
                  transform: "translateY(-50%)"
                }}
              />
              <input
                type="password"
                placeholder="Contraseña"
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "calc(100% - 25px)", // <-- CAMBIO CLAVE
                  padding: "10px",
                  fontSize: "16px",
                  border: "2px solid #F25C05",
                  borderRadius: "6px",
                  outline: "none",
                  textAlign: "center",
                  fontStyle: "italic" // <-- ESTO HACE QUE LA LETRA SEA CURSIVA
                }}
              />
            </div>

            {/* BOTONES - 50% exacto cada uno, con separación usando GAP */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",           // SEPARACIÓN
              marginBottom: "20px",
            }}>
              <Button
                variant="contained"
                style={{
                  background: "#F25C05",
                  color: "white",
                  width: "50%",       // NO se modifica
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                }}
                onClick={() => setOpenRegister(true)}
              >
                REGÍSTRATE
              </Button>
              <Button
                variant="contained"
                style={{
                  background: "#F25C05",
                  color: "white",
                  width: "51%",       // NO se modifica
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                }}
                onClick={() => login()}
              >
                INICIAR SESIÓN
              </Button>
            </div>

            {/* TEXTOS - mismo contenedor con GAP igual */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              fontSize: 14
            }}>
              <Button
                variant="text"
                style={{
                  color: "#F25C05",
                  textTransform: "none",
                  padding: 0,
                  minWidth: "50%",
                  textAlign: "left",
                  fontStyle: "italic" // <-- ESTO HACE QUE LA LETRA SEA CURSIVA
                }}
                onClick={() => setRecoverPassword(true)}
              >
                Olvidé mi contraseña
              </Button>
              <Button
                variant="text"
                style={{
                  color: "#F25C05",
                  textTransform: "none",
                  padding: 0,
                  minWidth: "50%",
                  textAlign: "right",
                  fontStyle: "italic" // <-- ESTO HACE QUE LA LETRA SEA CURSIVA
                }}
                onClick={() => (window.location.href = "https://electrofrenorr.co/")}
              >
                Volver a la tienda
              </Button>
            </div>

          </div>
        </div>
      )}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccess}
        autoHideDuration={6000}
        onClose={() => setOpenSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      {/* --- D I Á L O G O   R E G I S T R O  -------------------------------- */ }
      <Dialog
        open={openRegister}
        onClose={handleCloseRegister}
        fullWidth                // se adapta en móviles
        maxWidth="sm"            // ancho máx. → ~600 px
        PaperProps={{
          sx: {
            bgcolor: '#050A0E',          // mismo fondo que la app
            color: '#fff',
            borderRadius: 3,
            p: { xs: 2, md: 4 },
          },
        }}
      >
        {/* CABECERA --------------------------------------------------------- */}
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontStyle: 'italic',
            color: '#F25C05',
            textAlign: 'center',
            pb: 0,
          }}
        >
          ¡Crea tu cuenta!
        </DialogTitle>

        {/* TEXTO INTRO ------------------------------------------------------ */}
        <DialogContent>
          <Typography sx={{ mb: 3, textAlign: 'center' }}>
            Para registrarte ten a mano tu <b>código de usuario</b> y
            cualquier <b>documento vigente</b> (factura o cotización).
          </Typography>

          {/* FORMULARIO ---------------------------------------------------- */}
          <Stack spacing={2}>
            <TextField
              autoFocus
              label="Código de Usuario"
              variant="outlined"
              fullWidth
              onChange={(e) => setUsernameRegistro(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />

            <TextField
              label="Contraseña"
              type="password"
              variant="outlined"
              fullWidth
              onChange={(e) => setPasswordRegistro(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />

            <TextField
              label="Correo electrónico"
              type="email"
              variant="outlined"
              fullWidth
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />

            {/* RADIO TIPO DE DOCUMENTO ------------------------------------ */}
            <FormControl>
              <FormLabel
                sx={{ color: '#fff', fontWeight: 'bold', mb: 1 }}
              >
                Tipo de Documento
              </FormLabel>
              <RadioGroup
                row
                defaultValue="factura"
                onChange={(e) => setTipoDocumento(e.target.value)}
              >
                <FormControlLabel
                  value="factura"
                  control={<Radio sx={{ color: '#F25C05', '&.Mui-checked': { color: '#F25C05' } }} />}
                  label="Factura"
                />
                <FormControlLabel
                  value="cotizacion"
                  control={<Radio sx={{ color: '#F25C05', '&.Mui-checked': { color: '#F25C05' } }} />}
                  label="Cotización"
                />
              </RadioGroup>
            </FormControl>

            <TextField
              label="Número de documento vigente"
              variant="outlined"
              fullWidth
              onChange={(e) => setNumeroFactura(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />
          </Stack>
        </DialogContent>

        {/* ACCIONES -------------------------------------------------------- */}
        <DialogActions
          sx={{ px: { xs: 2, md: 4 }, pb: 3, justifyContent: 'center' }}
        >
          <Button
            onClick={handleCloseRegister}
            sx={{
              textTransform: 'none',
              fontStyle: 'italic',
              borderRadius: 3,
              px: 4,
              color: '#fff',
              backgroundColor: '#6c6c6c',
              '&:hover': { backgroundColor: '#7d7d7d' },
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={logup}
            sx={{
              ml: 2,
              textTransform: 'none',
              fontStyle: 'italic',
              fontWeight: 'bold',
              borderRadius: 3,
              px: 4,
              color: '#fff',
              backgroundColor: '#F25C05',
              '&:hover': { backgroundColor: '#ff7d2b' },
            }}
          >
            Suscribirse
          </Button>
        </DialogActions>
      </Dialog>


      {/* --- D I Á L O G O  ·  R E C U P E R A R  C L A V E  ----------------- */}
      <Dialog
        open={recoverPassword}
        onClose={() => setRecoverPassword(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            bgcolor: '#050A0E',
            color: '#fff',
            borderRadius: 3,
            p: { xs: 2, md: 4 },
          },
        }}
      >
        {/* CABECERA --------------------------------------------------------- */}
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontStyle: 'italic',
            color: '#F25C05',
            textAlign: 'center',
            pb: 0,
          }}
        >
          Recuperar Contraseña
        </DialogTitle>

        {/* CONTENIDO -------------------------------------------------------- */}
        <DialogContent>
          <Typography sx={{ mb: 3, textAlign: 'center' }}>
            Para cambiar tu clave necesitas la <b>contraseña maestra</b> de&nbsp;
            Electrofrenor. <br />Solicítala si la has olvidado.
          </Typography>

          <Stack spacing={2}>
            <TextField
              autoFocus
              label="Código de Usuario"
              fullWidth
              variant="outlined"
              onChange={(e) => setUsernameRegistro(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />

            <TextField
              label="Nueva Contraseña"
              type="password"
              fullWidth
              variant="outlined"
              onChange={(e) => setPasswordRegistro(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />

            <TextField
              label="Contraseña Maestra Electrofrenor"
              type="password"
              fullWidth
              variant="outlined"
              onChange={(e) => setMasterPasswordRegistro(e.target.value)}
              InputProps={{ sx: { color: '#fff' } }}
              InputLabelProps={{ sx: { color: '#ccc' } }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ff7d2b' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F25C05' },
              }}
            />
          </Stack>
        </DialogContent>

        {/* BOTONES ---------------------------------------------------------- */}
        <DialogActions sx={{ pb: 3, justifyContent: 'center' }}>
          <Button
            onClick={() => setRecoverPassword(false)}
            sx={{
              textTransform: 'none',
              fontStyle: 'italic',
              borderRadius: 3,
              px: 4,
              color: '#fff',
              backgroundColor: '#6c6c6c',
              '&:hover': { backgroundColor: '#7d7d7d' },
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={changePassword}
            sx={{
              ml: 2,
              textTransform: 'none',
              fontStyle: 'italic',
              fontWeight: 'bold',
              borderRadius: 3,
              px: 4,
              color: '#fff',
              backgroundColor: '#F25C05',
              '&:hover': { backgroundColor: '#ff7d2b' },
            }}
          >
            Cambiar Contraseña
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default App;
